package uk.co.nickthecoder.kyd

enum class SizeConstraint(val label: String) {

    NONE("None"),
    LETTERBOX("Letterbox");

    override fun toString() = label
}
